import React, { useEffect, useState } from "react";
import {
  Users,
  Search,
  Mail,
  Settings,
  HelpCircle,
  ShoppingBag,
  ShoppingBasket,
  ListOrdered,
  Wallet,
  BoxesIcon,
  ImageIcon,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const UserCard = () => {
  const navigate = useNavigate();
  const adminCards = [
    // {
    //   title: "Image to HTML Generator",
    //   link: "/user/generate-code",
    //   linkText: "Generate Now",
    //   icon: <ImageIcon size={32} />,
    //   value: "",
    //   growth: "",
    //   bgColor: "bg-primary",
    //   iconColor: "text-primary",
    //   borderColor: "border-primary",
    //   isAnimated: true,
    // },
    {
      title: "Pending Payments",
      link: "/user/pending-payment/",
      linkText: "View Pending Payments",
      icon: <Wallet size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-secondary",
      iconColor: "text-secondary",
      borderColor: "border-secondary",
    },
    {
      title: "Support",
      link: "/user/support",
      linkText: "Get help & support",
      icon: <HelpCircle size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-info",
      iconColor: "text-info",
      borderColor: "border-info",
    },
    {
      title: "Subscription History",
      link: "/user/subscription-history",
      linkText: "View your subscriptions",
      icon: <ShoppingBasket size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-secondary",
      iconColor: "text-secondary",
      borderColor: "border-secondary",
    },
    {
      title: "Upgrade Package",
      link: "/user/select-package",
      linkText: "Upgrade your package",
      icon: <BoxesIcon size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-secondary",
      iconColor: "text-secondary",
      borderColor: "border-secondary",
    },
  ];

  const handleCardClick = (link) => {
    navigate(link); // Navigate to the route
  };

  return (
    <div className="container py-4">
      <style jsx>{`
        @keyframes pulse-search {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        @keyframes glow {
          0%,
          100% {
            box-shadow: 0 0 15px rgba(138, 43, 226, 0.4);
            border-color: #8a2be2 !important;
          }
          50% {
            box-shadow: 0 0 25px rgba(138, 43, 226, 0.7),
              0 0 35px rgba(138, 43, 226, 0.5);
            border-color: #9932cc !important;
          }
        }

        .animate-search {
          animation: pulse-search 2s ease-in-out infinite;
        }

        .premium-card {
          position: relative;
          overflow: hidden;
          animation: glow 2s ease-in-out infinite;
          background: linear-gradient(
            45deg,
            #8a2be2,
            #9932cc,
            #ba55d3
          ) !important;
        }

        .premium-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          animation: shimmer 3s ease-in-out infinite;
          z-index: 1;
        }

        .premium-card .card-body {
          position: relative;
          z-index: 2;
        }

        .premium-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background: linear-gradient(45deg, #ff6b6b, #ee5a52);
          color: white;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 10px;
          font-weight: bold;
          z-index: 3;
          animation: pulse-search 2s ease-in-out infinite;
          text-transform: uppercase;
        }

        .card-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
        }

        .bg-light-primary {
          background-color: rgba(13, 110, 253, 0.1) !important;
        }

        .bg-light-success {
          background-color: rgba(25, 135, 84, 0.1) !important;
        }

        .bg-light-warning {
          background-color: rgba(255, 193, 7, 0.1) !important;
        }

        .bg-light-secondary {
          background-color: rgba(108, 117, 125, 0.1) !important;
        }

        .bg-light-info {
          background-color: rgba(13, 202, 240, 0.1) !important;
        }
        @keyframes rainbowBackground {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        @keyframes borderPulse {
          0%,
          100% {
            box-shadow: 0 0 10px #ff00cc, 0 0 20px #3333ff;
          }
          50% {
            box-shadow: 0 0 20px #33ccff, 0 0 40px #ff66cc;
          }
        }

        .rainbow-animated-btn {
          position: relative;
          display: inline-block;
          font-size: 1.4rem;
          font-weight: 700;
          padding: 18px 40px;
          color: #fff;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          background: linear-gradient(
            270deg,
            #ff00cc,
            #3333ff,
            #33ccff,
            #ff6600,
            #ff00cc
          );
          background-size: 400% 400%;
          animation: rainbowBackground 16s linear infinite,
            borderPulse 6s ease-in-out infinite;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          z-index: 1;
          overflow: hidden;
        }

        .rainbow-animated-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 0 30px rgba(255, 0, 204, 0.7),
            0 0 50px rgba(51, 51, 255, 0.5);
        }
      `}</style>

      <div className="row mb-4">
        <div className="col-12">
          <p className="text-center mb-0">
            Welcome to the Dashboard. Generate stunning images with ease!
          </p>
          {/* <NoticeLeads /> */}
        </div>
      </div>

      <div className="row g-4">
        {adminCards.map((card, index) => (
          <div key={index} className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div
              onClick={() => handleCardClick(card.link)}
              className={`
                card h-100 border-2 shadow-sm card-hover text-decoration-none
                ${
                  card.isPremium
                    ? "premium-card border-primary"
                    : `${card.borderColor} bg-white`
                }
              `}
              style={{
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              {card.isPremium && <div className="premium-badge">Premium</div>}

              <div
                className={`card-body p-4 ${
                  card.isPremium
                    ? ""
                    : `bg-light-${card.bgColor.replace("bg-", "")}`
                }`}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div
                    className={`p-3 rounded-circle bg-white shadow-sm ${
                      card.iconColor
                    } ${card.isAnimated ? "animate-search" : ""}`}
                  >
                    {card.icon}
                  </div>
                  {card.growth && (
                    <span className="badge bg-success fs-6 p-2">
                      {card.growth}
                    </span>
                  )}
                </div>

                <h5
                  className={`card-title mb-2 fw-bold ${
                    card.isPremium ? "text-white" : "text-dark"
                  }`}
                >
                  {card.title}
                </h5>

                {card.value && (
                  <h3
                    className={`display-6 fw-bold mb-2 ${
                      card.isPremium ? "text-white" : "text-dark"
                    }`}
                  >
                    {card.value}
                  </h3>
                )}

                <small
                  className={`card-text ${
                    card.isPremium ? "text-white-50" : "text-muted"
                  }`}
                >
                  {card.linkText}
                </small>
              </div>
            </div>
          </div>
        ))}
      </div>
     
    </div>
  );
};

export default UserCard;
